import axios from 'axios';
import realnameStore from './model';

export function getRealname() {
    axios.get('/zhgd/index/realNameInfo?pageNo=1&pageSize=10000&type=0')
        .then((data) => {
            realnameStore.setRealnames(data.result || []);
        })
        .catch((e) => console.log(e));
}

export function getPersons() {
    axios.get('/zhgd/brake/person/manager/brake/xapt/person')
        .then((data) => {
            realnameStore.setPersons(data.result || []);
        })
        .catch((e) => console.log(e));
}
